import { PropsWithChildren } from "react";
import ReactModal, { Props as ModalProps } from "react-modal";
import styles from "./modal.module.scss";

const Modal = ({ children, ...props }: PropsWithChildren<ModalProps>) => {
  return (
    <ReactModal
      className={{
        base: styles.modal,
        afterOpen: styles.modalOpen,
        beforeClose: styles.modalClosed,
      }}
      overlayClassName={{
        base: styles.overlay,
        afterOpen: styles.overlayOpen,
        beforeClose: styles.overlayClosed,
      }}
      closeTimeoutMS={150}
      {...props}
    >
      {children}
    </ReactModal>
  );
};

export default Modal;
